import designTokens from 'theme/design-tokens';

export default designTokens.zindex;
